import { CSSProperties, FC } from 'react'

import { Empty } from 'packages/components/Empty'
import { AlignWrapper } from 'packages/route/components/AlignWrapper'

/**
 * 全屏空状态
 *
 * @param param0 - 参数
 * @param param0.style - 样式
 * @returns 组件
 */
export const FullscreenEmpty: FC<{
  style?: CSSProperties
}> = ({ style }) => {
  return (
    <AlignWrapper style={style}>
      <Empty />
    </AlignWrapper>
  )
}
